/**
 * Protected Route Component
 * Wraps routes that require authentication
 * Redirects to login if user is not authenticated
 */

import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { consoleRoutePatterns } from '@/navigation/consoleRoutePaths';
import { useAuthStore, useIsAuthenticated } from '../../stores/authStore';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useIsAuthenticated();
  const sessionStatus = useAuthStore((state) => state.sessionStatus);
  const location = useLocation();

  if (sessionStatus === 'checking') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-canvas text-ink">
        <p role="status">Checking your session…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login, but save the attempted URL
    return <Navigate to={consoleRoutePatterns.login} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
